<template>
  <div class="mine">
    <div class="body">
      <div class="nav">
        管理员给你分配了
        <span>{{ count }}</span
        >个好友,快去复制电话号码添加客户吧,管理员在后台可查看添加状态哦
      </div>
      <div class="nav_tow">
        <div class="ziti">
          共
          <span>{{ count }}</span
          >个客户
        </div>
        <div>
          <van-dropdown-menu>
            <van-dropdown-item
              v-model="value1"
              :options="option1"
              @change="aaa"
            />
          </van-dropdown-menu>
        </div>
      </div>
      <div class="liebiao">
        <span>客户电话</span>
        <span>添加状态</span>
        <span>复制</span>
      </div>
      <div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-cell v-for="item in list" :key="item.id">
            <div class="liebiao_neibu">
              <span v-if="item.if_copy == 1" style="color: red">{{
                item.remark_mobiles
              }}</span>
              <span v-else>{{ item.remark_mobiles }}</span>
              <span>{{ item.is_status }}</span>
              <span>
                <van-button type="primary" @click="about(item)"
                  >复制</van-button
                >
              </span>
            </div>
          </van-cell>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import { List } from "vant";
import { DropdownMenu, DropdownItem } from "vant";

export default {
  name: "mine",
  components: {
    DropdownMenu,
    DropdownItem,
  },
  data() {
    return {
      option1: [
        { text: "添加状态", value: 3 },
        { text: "未成功添加", value: 0 },
        { text: "已成功添加", value: 1 },
      ],
      value1: 3,
      list: [],
      loading: false,
      finished: false,
      count: "",
      page: "0",
      mop: {},
      account_id: "",
      userid: "",
    };
  },
  created() {
    if (localStorage.getItem("userid_obse")) {
      return;
    }
    if (!this.$route.query.code) {
      //没有code进行授权跳转
      const redirect_uri = encodeURIComponent(location.href);
      location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww6c09e0292217ba48&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=#wechat_redirect`;
    }
  },
  watch: {
    async $route() {
      if (this.$route.query.code) {
        //如果有code请求接口
        try {
          const data = qs.stringify({
            infocode: this.$route.query.code,
          });
          const result = await this.axios({
            url: "/crm/Mymine/updateInfo",
            method: "POST",
            data,
          });
          if (result.data.code == 1) {
            localStorage.setItem("userid_obse", result.data.data.userid);
            localStorage.setItem(
              "account_id_obse",
              result.data.data.account_id
            );
            this.$router.push({
              name: "logins",
            });
          } else if (result.data.code == 0) {
            const msg = "没有获取到用户信息，请联系企业管理员添加该应用";
            this.unAuthorized(msg);
          }
        } catch (error) {}
      }
    },
  },
  mounted() {
    if (this.$route.query.account_id) {
      localStorage.setItem("account_id", this.$route.query.account_id);
      localStorage.setItem("userid", this.$route.query.userid);
      this.account_id = window.localStorage.getItem("account_id");
      this.userid = window.localStorage.getItem("userid");
    } else {
      this.account_id = window.localStorage.getItem("account_id_obse");
      this.userid = window.localStorage.getItem("userid_obse");
    }
    this.userTable();
  },
  methods: {
    unAuthorized(msg) {
      // 无法获取到用户信息给予提示，并关闭浏览器
      this.$dialog({
        message: msg,
      }).then(() => {
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              weixin_ClosePage,
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", weixin_ClosePage);
            document.attachEvent("onWeixinJSBridgeReady", weixin_ClosePage);
          }
        } else {
          WeixinJSBridge.call("closeWindow");
        }
      });
    },
    about(e) {
      // 复制
      const input = document.createElement("input");
      input.setAttribute("readonly", "readonly");
      // 把input.setAttribute里的第二个参数改成你要复制的东西就可以
      input.setAttribute("value", `${e.remark_mobiles}`);
      document.body.appendChild(input);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        this.$message.success("复制成功");
      }
      document.body.removeChild(input);
      this.axios
        .post(
          "/crm/CircleFriends/phoneIfCopy",
          qs.stringify({
            account_id: this.account_id,
            id: e.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.userTable();
        })
        .catch(function (err) {});
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      if (this.mop.last_page <= this.page) {
        this.finished = true;
        return;
      } else {
        if (this.page == 1) {
          return;
        } else {
          this.page = this.page * 1 + 1;
          this.axios
            .post(
              "/crm/CircleFriends/getPhoneByUser",
              qs.stringify({
                account_id: this.account_id,
                userid: this.userid,
                is_status: this.value1,
                page: this.page,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              this.loading = false;
              for (var i = 0; i < res.data.data.data.lenth - 1; i++) {
                this.list.push(res.data.data.data[i]);
              }
            })
            .catch(function (err) {});
        }
      }
    },
    aaa() {
      this.userTable();
    },
    userTable() {
      this.axios
        .post(
          "/crm/CircleFriends/getPhoneByUser",
          qs.stringify({
            account_id: this.account_id,
            userid: this.userid,
            is_status: this.value1,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.list = res.data.data.data;
          this.count = res.data.data.total;
          this.mop = res.data.data;
        })
        .catch(function (err) {});
    },
  },
};
</script>
<style lang="scss" scope>
::v-deep.van-cell {
  -webkit-box-shadow: 0 0 1.0rem #fff;
  box-shadow: 0 0 1.0rem #fff;
  margin-top: 0;
}
</style>
<style scoped>
.body {
  width: 80%;
  margin: 0 auto;
}
.nav {
  margin-top: 2.0rem;
  padding: 1.0rem;
  color: rgb(146, 109, 80);
  background-color: rgb(255, 246, 239);
}

.nav_tow {
  margin-top: 2.0rem;
  display: flex;
  justify-content: space-between;
}
.ziti {
  line-height: 5.0rem;
}
.liebiao {
  width: 100%;
  height: 5.0rem;
}
.liebiao > span {
  display: inline-block;
  width: 33%;
  height: 100%;
  line-height: 5.0rem;
  text-align: center;
  background-color: rgb(238, 250, 252);
}
.liebiao_neibu {
  height: 5.0rem;
  display: flex;
  justify-content: space-between;
}
.liebiao_neibu > span {
  line-height: 5.0rem;
  display: inline-block;
}
</style>
